module.exports = __webpack_public_path__ + "img/hero-icon-bones-3.cd6f93cc.svg";